import Stack from "components/Stack/Stack";
import { useSubtitles } from "funkis-template/hooks/subtitles";
import { PageItemMedia } from "funkis-template/models/player";
import { FC } from "react";

type VideoTranscriptionProps = {
	src: PageItemMedia;
};

const VideoTranscription: FC<VideoTranscriptionProps> = ({ src }) => {
	const subtitles = useSubtitles(src);

	return (
		<Stack spacing="small">
			{subtitles.map((subtitle) => (
				<p key={`${subtitle.enter}-${subtitle.exit}`}>{subtitle.text}</p>
			))}
		</Stack>
	);
};

export default VideoTranscription;
